import {Typography} from "antd"
import {dataService} from "services/data.service"
import SideEffectGraph from "components/graph/SideEffectGraph"
import { useTranslation } from 'react-i18next'
import React from 'react';

export default function DrugInfo({drug}) {
	const { t } = useTranslation();
	const paragraphKeys = dataService.getParagraphKeys(drug); //New

	// Function to render the section with header and content
	const renderSection = (key) => {
		const sectionMap = {
			'indication': 'section.indication',
			'sideEffects': 'section.sideEffects',
			'administration': 'section.administration',
			'degradation': 'section.degradation',
		};
		// Split the key by dots and get the last part for the section identifier.
		const sections = key.split('.');
		const sectionKey = sections[sections.length - 1]; // Get the last element after the split.
		const sectionTranslationKey = sectionMap[sectionKey];


		const headerTranslation = t(sectionTranslationKey || `section.${sectionKey}`);
		const contentTranslation = t(key);


		return (
			<React.Fragment key={key}>
				<Typography.Title level={5} style={{ fontWeight: 'bold' }}>
					{headerTranslation} {/* Translate the section header */}
				</Typography.Title>
				<Typography.Paragraph>
					{contentTranslation} {/* Translate the section content */}
				</Typography.Paragraph>
			</React.Fragment>
		);
	};

	return (
		<div className="drug-info">
			<div className="drug-info-left">
				{paragraphKeys?.map(renderSection)}
			</div>
			<SideEffectGraph mainDrug={drug}/>
		</div>
	)
}
